interface Slot {
  orario: string;
  data: string;
}

interface Props {
  slotDisponibili: Slot[];
}

export default function AvailableSlotsList({ slotDisponibili }: Props) {

    const formatTime = (time: string) => time.slice(0, 5);


    if (slotDisponibili.length === 0) {
        return (
            <div className="text-center text-gray-500 py-8">
                Nessuno slot disponibile
            </div>
        );
    }

    return (
        <div className="grid grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
            {slotDisponibili.map((slot: { orario: string }) => (
                <div
                    key={slot.orario}
                    className="px-2 py-1.5 text-center rounded-lg border bg-green-50 text-green-700 font-semibold"
                >
                    {formatTime(slot.orario)}
                </div>
            ))}
        </div>
    );
}